import React, { useEffect, useState, useRef } from 'react'
import styled, { css } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { Pagination, Autoplay, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
// eslint-disable-next-line import/no-unresolved
import 'swiper/css'
import { AxiosError, AxiosResponse } from 'axios'
import Benefits from '@components/Benefits'
import Banner from '@components/Banner'
import Container from '@components/Container'
import { SH2, SH3, STypographyLarge } from '@components/Typography'
import Layout from '@components/Layout'
import { above } from '@styles/mixins/breakpoints'
import Box from '@components/Box'
import Cards from '@components/Cards'
import CardImage1 from '@images/card-image-1.jpg'
import CardImage2 from '@images/card-image-2.jpg'
import CardImage3 from '@images/card-image-3.jpg'
import CardImage4 from '@images/card-image-4.jpg'
import CardImage5 from '@images/card-image-5.jpg'
import CardImage6 from '@images/card-image-6.jpg'
import Modal from '@components/Modal'

import SliderArrow from '@icons/npf-banner-arrow.inline.svg'
import { xl, md } from '@styles/variables/breakpoints'
import SocialPackBlock from '@components/SocialPackBlock'
import theme from '@styles/theme'
import Steps from '@components/Steps'
import Calc from '@components/Calc'
import SmallBanner from '@components/Banner/SmallBanner'
import WithMedia from '@components/Utils/withMedia'
import Form from '@api/Form'
import { TServerData, TBanner, TSlider, TBenefit } from '@api/Form'
import CookiePopUp from '@components/CookiePopUp/Cookie-popup'
import VideoPlayer from '@/VideoPlayer/VideoPlayer'

type IBanner = {
  image?: string
  isVideo?: boolean
}

const SBanner = styled(Banner)<IBanner>`
  background-image: url(${({ image }) => image});
  background-size: 320px auto;
  background-repeat: no-repeat;
  background-position: bottom 98px right 50%;
  max-width: 1200px;
  max-height: 380px;
  display: flex;

  & .markets {
    color: ${({ theme }) => theme.colors.darkGray};
    font-weight: 600;
  }

  & .qrCode {
    right: 90px;
    bottom: 31px;
  }

  ${above('md')(
    css`
      padding-right: ${({ isVideo }) => (isVideo ? 0 : '276px')};
      padding-left: ${({ isVideo }) => (isVideo ? 0 : '40px')};
      background-size: 420px auto;
      background-position: bottom 0px right 0px;
    `,
  )}

  ${above('xl')(css`
    background-size: 676px auto;
    background-position: bottom 0px right 20px;
  `)}
`

const SSwiper = styled(Swiper)`
  @keyframes npf-pagination {
    0% {
      width: 0;
    }

    100% {
      width: 100%;
    }
  }
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  overflow: hidden;
  & .swiper-slide {
    transition: 0.3s;
  }
  & .swiper-pagination {
    display: block;
    z-index: 10;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 15px;
    ${above('md')(css`
      transform: none;
      left: 40px;
      bottom: 40px;
    `)}

    ${above('xl')(css`
      display: none;
    `)}
  }
  & .swiper-pagination-bullet {
    overflow: hidden;
    margin: 0 2px;
    width: 6px;
    display: inline-block;
    height: 6px;
    border-radius: 3px;
    background: ${({ theme }) => theme.colors.green};
    opacity: 1;
    transition: 0.2s;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &.swiper-pagination-bullet-active {
      background: ${({ theme }) => theme.colors.green};
    }

    &.swiper-pagination-bullet-active {
      width: 32px;
      background: rgba(0, 0, 0, 0.2);

      & ~ .swiper-pagination-bullet {
        background: rgba(0, 0, 0, 0.2);
      }

      &:before {
        display: block;
        width: 0;
        height: 100%;
        border-radius: 3px;
        background: ${({ theme }) => theme.colors.green};
        content: '';
        animation: npf-pagination 5s linear forwards; // Если меняешь длительность здесь, меняй еще и длительность переключения слайдов в скрипте
      }
    }
  }
  .swiper-button-next,
  .swiper-button-prev {
    position: static;
    z-index: 10;
    top: 50%;
    display: flex;
    justify-content: center;
    right: 10px;
    left: auto;
    align-items: center;
    content: 'next';
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.96);
    border-radius: 8px;
    cursor: pointer;
    transition: 0.3s;
    user-select: none;
    & svg {
      width: 32px;
      height: 32px;
    }
    &.swiper-button-disabled {
      cursor: default;
      opacity: 0.5;
      &:hover {
        background: rgba(255, 255, 255, 0.96);
      }
    }
    svg {
      path {
        transition: 0.3s;
      }
    }
    &:not(.swiper-button-disabled) {
      &:hover {
        background: #21a038;
        svg {
          path {
            fill: #fff;
          }
        }
      }
    }
  }
  .swiper-button-prev {
    right: auto;
    left: 10px;
    margin-right: 4px;
  }
  .swiper-button-next {
    svg {
      transform: rotate(180deg);
    }
  }
`

const NavContainer = styled(Box)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1200px;
  display: none;
  bottom: 40px;
  z-index: 10;
  justify-content: flex-end;
  ${above('xl')(css`
    display: flex;
  `)}
`

const Nav = styled(Box)`
  display: flex;
  position: relative;
  align-items: center;
`
export const FORM_URL = '#form'

export const VideoBanner = (image: string, index: number, closeHandler: (i: number) => void) => (
  <div className={`npf-main-banner__image-wrap_default  npf-main-banner__image-wrap_video `}>
    <Box className="fake-youtube" maxHeight={'265px'}>
      <div className="fake-youtube__wrapper" onClick={() => closeHandler(index)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" fill="#fff">
          <path
            fill-rule="evenodd"
            d="M44 88C19.738 88 0 68.262 0 44S19.738 0 44 0s44 19.738 44 44-19.738 44-44 44zm0-85C21.393 3 3 21.393 3 44c0 22.608 18.393 41 41 41s41-18.392 41-41C85 21.393 66.607 3 44 3zm16.063 43.898L39.629 60.741a3.496 3.496 0 0 1-3.604.194 3.492 3.492 0 0 1-1.859-3.092V30.158c0-1.299.712-2.483 1.859-3.092a3.487 3.487 0 0 1 3.604.194l20.433 13.843a3.497 3.497 0 0 1 .001 5.795zm-1.683-3.311L37.946 29.744a.49.49 0 0 0-.276-.09.51.51 0 0 0-.239.062.483.483 0 0 0-.265.442v27.685c0 .262.166.389.265.442.1.053.299.118.515-.028L58.38 44.414A.489.489 0 0 0 58.6 44a.49.49 0 0 0-.22-.413z"
          ></path>
        </svg>
      </div>
      <img className="fake-youtube__image" src={image} alt="" />
    </Box>
  </div>
)

const Index: React.FC = () => {
  const [blocks, setBlocks] = useState<{
    landingBanner: TBanner[]
    landingSlider: TSlider[]
    landingBenefits: TBenefit[]
  } | null>(null)

  const [selectedModal, setselectedModal] = useState(-1)

  const formRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (history?.scrollRestoration) {
      history.scrollRestoration = 'manual'
    }
    if (window && window.location.hash !== '#form') {
      setTimeout(() => {
        window.scrollTo(0, 0)
        document.body.focus()
      }, 1)
    }
    const request = Form.get()
    request
      .then((data: AxiosResponse<TServerData>) => {
        setBlocks(data?.data.result)
      })
      .catch((err: AxiosError) => {
        console.log(err)
      })
  }, [])

  const scrollToForm = () => {
    const formNode = formRef.current
    formNode?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  const clickVideoHandler = (i: number) => {
    setselectedModal(i)
  }

  const banner = blocks?.landingBanner?.[0]
  return (
    <Layout
      contacts="8 495 784 73 30"
      contractHref="https://npfsberbanka.ru/corp?utm_source=sbernpfsite&utm_medium=kppheader&utm_campaign=getcontract"
      formRef={formRef}
    >
      <SSwiper
        loop={true}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        watchSlidesProgress={true}
        init={true}
        modules={[Pagination, Autoplay, Navigation]}
        autoplay={{
          delay: 5000, //Если меняешь задержку здесь, меняй еще и длительность анимации в стилях
          disableOnInteraction: false,
        }}
        initialSlide={1}
        pagination={{ clickable: true }}
      >
        {blocks?.landingSlider?.map((slide, i) => (
          <SwiperSlide key={i}>
            <Box style={{ backgroundColor: slide.bg_color }}>
              {!slide.video_link ? (
                <SBanner
                  title={slide.name}
                  text={slide.title}
                  link={{
                    handle: scrollToForm,
                    text: slide.button_text,
                  }}
                  image={slide.image}
                />
              ) : (
                <div className="npf-container npf-main-banner__container">
                  <SBanner
                    title={slide.name}
                    text={slide.title}
                    link={{
                      handle: scrollToForm,
                      text: slide.button_text,
                    }}
                    isVideo={true}
                  >
                    <Box display={{ _: 'block', md: 'none' }} mt="20px">
                      {VideoBanner(slide.image, i, clickVideoHandler)}
                    </Box>
                  </SBanner>
                  <Box display={{ _: 'none', md: 'contents' }}>{VideoBanner(slide.image, i, clickVideoHandler)}</Box>
                </div>
              )}
            </Box>
          </SwiperSlide>
        ))}
        <NavContainer>
          <Nav>
            <Box className="swiper-button-prev">
              <SliderArrow />
            </Box>
            <Box className="swiper-button-next">
              <SliderArrow />
            </Box>
          </Nav>
        </NavContainer>
      </SSwiper>
      <Container mt={'40px'} mb={{ xs: '40px', md: '60px', xl: '80px' }} display="block">
        {blocks?.landingBenefits && <Benefits heading="О фонде" cards={blocks?.landingBenefits} />}
      </Container>
      <Container mt={{ xs: '40px', md: '60px', xl: '80px' }} mb="40px" display="block">
        <SH2 mb="12px">Сколько стоит социальный пакет на&nbsp;вашу&nbsp;команду?</SH2>
        <STypographyLarge mb="32px" mr={{ md: '100px', xl: 0 }}>
          Мы проанализировали рынок и узнали сколько стоит классический социальный пакет для малого бизнеса
        </STypographyLarge>
        <SocialPackBlock
          additionText="Не является офертой. Данные для расчета среднерыночной стоимости социального пакета получены из общедоступных источников и СМИ."
          mainItem={{ cost: '131 800 ₽', text: 'Среднерыночная стоимость в&nbsp;год&nbsp;на&nbsp;одного сотрудника' }}
          items={[
            { cost: '100 000 ₽', text: 'Добровольное медицинское&nbsp;страхование' },
            { cost: '6 000 ₽', text: 'Страхование от&nbsp;несчастного&nbsp;случая' },
            { cost: '25 800 ₽', text: 'Затраты на&nbsp;образование' },
          ]}
        />
      </Container>
      <Container
        mb={{ xs: '40px', md: '24px', xl: '80px' }}
        mt={{ xs: '40px', md: '60px', xl: '80px' }}
        display="block"
      >
        <SH2 mb="12px">
          Что делать, если бюджета
          <br /> на социальный пакет не&nbsp;хватает?
        </SH2>
        <SH3 mb={{ xs: '24px', xl: '40px' }} color={theme.colors.green}>
          Подключите корпоративную пенсионную{' '}
          <WithMedia minWidth={md} maxWidth={xl}>
            <br />
          </WithMedia>
          программу «Умный&nbsp;социальный&nbsp;пакет»
        </SH3>
        <Cards
          items={[
            { image: CardImage1, title: 'Может заменить все&nbsp;необходимые элементы социального пакета' },
            { image: CardImage2, title: 'Обеспечит комплексную материальную помощь&nbsp;сотруднику' },
            {
              image: CardImage3,
              title: 'Оптимизирует расходы на&nbsp;мотивацию сотрудников за&nbsp;счет&nbsp;налоговых льгот',
            },
          ]}
        />
      </Container>
      <Container
        mb={{ xs: '40px', md: '60px', xl: '80px' }}
        mt={{ xs: '40px', md: '24px', xl: '80px' }}
        pr={{ xl: '237px' }}
        display="block"
      >
        <SH2 mb="32px">Как работает корпоративная пенсионная программа?</SH2>
        <Steps
          steps={[
            {
              heading: 'Взносы в НПФ',
              text: 'Компания делает взносы для&nbsp;сотрудников с&nbsp;удобной периодичностью',
            },
            { heading: 'Инвестирование', text: 'Фонд инвестирует средства&nbsp;и&nbsp;ежегодно начисляет&nbsp;доход' },
            {
              heading: 'Выплата накоплений',
              text: 'Условия получения сотрудниками накоплений&nbsp;могут быть&nbsp;настроены в&nbsp;зависимости&nbsp;от&nbsp;целей компании',
            },
          ]}
        />
      </Container>
      <Container my={{ xs: '40px', md: '60px', xl: '80px' }} display="block">
        <SH2 mb={{ xs: '24px', xl: '36px' }}>Как сотрудник может&nbsp;использовать накопления?</SH2>
        <Cards
          isExtended
          items={[
            { image: CardImage4, title: 'Получить дополнительную пенсию', text: 'при достижении пенсионных оснований' },
            {
              image: CardImage5,
              title: 'Оплатить лечение критических заболеваний',
              text: 'через 5 лет участия за&nbsp;счет&nbsp;выкупной суммы',
            },
            {
              image: CardImage6,
              title: 'Оплатить образование ребёнка или&nbsp;взнос&nbsp;по&nbsp;ипотеке',
              text: 'через 5 лет участия за&nbsp;счет&nbsp;выкупной суммы',
            },
          ]}
        />
      </Container>
      <Container my={{ xs: '40px', md: '60px', xl: '80px' }} display="block">
        <SH2 mb="24px">Сколько стоит «Умный социальный пакет» на одного сотрудника?</SH2>
        <Calc scrollToForm={scrollToForm} />
      </Container>
      <Container display="block">
        {banner && (
          <>
            <WithMedia minWidth={xl}>
              <SmallBanner
                title={banner.name}
                text={banner.title}
                image={banner.image_desktop}
                bgColor={banner.bg_color}
              />
            </WithMedia>
            <WithMedia minWidth={md} maxWidth={xl}>
              <SmallBanner
                title={banner.name}
                text={banner.title}
                image={banner.image_tablet}
                bgColor={banner.bg_color}
              />
            </WithMedia>
            <WithMedia maxWidth={md}>
              <SmallBanner
                title={banner.name}
                text={banner.title}
                image={banner.image_mobile}
                bgColor={banner.bg_color}
              />
            </WithMedia>
          </>
        )}
      </Container>
      {blocks?.landingSlider?.map((video, i) => {
        return (
          video.video_link && (
            <Modal
              isOpen={i === selectedModal}
              onClose={() => setselectedModal(-1)}
              key={i}
              linkVideo={video.video_type ? video.video_link : ''}
            >
              {!video.video_type && <VideoPlayer link={video.video_link} />}
            </Modal>
          )
        )
      })}

      <CookiePopUp />
    </Layout>
  )
}

export default Index
